module.exports = "/_next/static/images/EnergyCardImage-a96faf9daac204c3290c24dbae34f373.webp";